/* eslint-disable react/prop-types */
/* eslint-disable camelcase */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError, formValueSelector } from 'redux-form';
import { Navigation } from '../../navigation/react-redux-nav';
import {
  loginWithEmail,
  connectFacebook,
  setUserAuthCredentials,
  getPlanetFitnessAuth,
  getLoginWithApple,
  loginViaPlanetFitnessSSO,
  loginWithPlanetFitness,
  acceptToS
} from '../../store/ducks/user';
import { openTermsOfUse, openPrivacyPolicy } from '../../store/ducks/shared';
import { closeWebview } from '../../store/ducks/shared';
import Icon, { NAMES } from '@ifit/react-icons';
import MuiRaisedButton from 'material-ui/RaisedButton';
import MuiCheckIcon from 'material-ui/svg-icons/navigation/check';
import { TextField as MuiTextField } from 'redux-form-material-ui';
import InputIconDecorator from '../../components/input-icon-decorator';
import withFacebookLogin from '../../components/with-fb-login';
import FloatingBar from '../../components/floating-bar';
import PasswordField from '../../components/password-field';
import { scienceBlue, greenApple, solidBlack } from '../../theme/colors';
import classNames from 'classnames';
import styles from '../../shared-styles';
import ConfirmAccountModal from './confirm-account-modal';
import pfLogo from './img/pf-gear.svg';
import PFLogin from '../../components/pf-login';
import PFStatus from '../../components/pf-status';
import PFConnecting from '../../components/pf-connecting';
import * as LDClient from 'launchdarkly-js-client-sdk';

import './index.css';

const emailRegex = /^[^@^\s]+@[^@^\s]+\.[^@^\s]+$/;

export const validate = (values) => {
  const errors = {};
  if (values.email && values.email.indexOf('@') > -1 && !emailRegex.test(values.email)) errors.email = 'Valid email required.';
  if (!values.password) errors.password = 'Password field required.';
  return errors;
};

const trim = value => value && value.trim();

export class PureLoginWithEmailPage extends Component {
  state = {
    showConfirmAccountModal: false,
    isAppleLoginPending: false,
    isPFLoginPending: Boolean(this.props.planetFitnessSSOCode),
    PFError: null,
    userCancelledPFLogin: false,
    shouldUseAuth0SDK: true,
    shouldShowPFLogin: null,
  };

  constructor(props) {
    super(props);

    if (props.planetFitnessSSOCode) {
      this.handleSSO();
    }
  }

  handleSSO = async () => {
    try {
      const result = await this.props.loginViaPlanetFitnessSSO(this.props.planetFitnessSSOCode);

      this.handlePFResult(result);
    } catch (e) {
      this.setState({
        isPFLoginPending: false,
        PFError: {
          message: "It looks like you don't have a paid membership with Planet Fitness. If you'd like access, please upgrade your membership today!",
          buttonText: 'Go Back',
          action: this.goBackFromError
        }
      });
    }
  }

  goBackFromError = () => {
    this.setState({ PFError: null });
  }

  loginViaFacebook = async () => {
    this.setState({ appleError: undefined, userCancelledPFLogin: false });
    try {
      await this.props.facebookLogin.login();
      this.props.onSuccessfulLogin();
    } catch (err) {
      if (err.message.indexOf('Provider user is not an iFit user') > -1) {
        this.setState({ showConfirmAccountModal: true });
      }
      // any other error will be in props.facebookLogin.error
    }
  }

  submitForm = async (values) => {
    this.setState({ appleError: undefined, userCancelledPFLogin: false });
    this.props.facebookLogin.clearErrors();
    if (!values.email) {
      throw new SubmissionError({
        email: 'Email field required.'
      });
    }
    try {
      const { value: { id, firstname, lastname } } = await this.props.loginViaEmail(values.email, values.password);
      if (this.props.facebookToken) {
        await this.props.connectFacebook(this.props.facebookToken);
      }

      try {
        if (window.analytics) {
          window.analytics.identify(id, {
            email: values.email,
            firstname,
            lastname
          });
          window.analytics.track(
            'user_login_app',
            {
              email: values.email,
              timestamp: new Date().toISOString()
            }
          );
        }

        // Segment recommends a delay between track calls and redirects
        await this.delayForAnalytics(); // :(
      } catch (e) {
        // fail silently
      }

      this.props.onSuccessfulLogin();
    } catch (e) {
      throw new SubmissionError({ _error: 'Email/Username or Password is incorrect.' });
    }
  }

  delayForAnalytics = async () => {
    return new Promise((res, rej) => {
      setTimeout(res, 300);
    });
  }

  handleWolfBack = () => {
    this.props.closeWebview();
  }

  clearPassword = () => {
    if (this.props.error) {
      this.props.clearFields('email-login', false, false, 'password');
    }
  }

  setFocusOnPW = (e) => {
    if (e.key.toLowerCase() === 'enter') {
      const pwInput = document.body.querySelector('input[type="password"]');
      if (pwInput && pwInput.focus) pwInput.focus();
    }
  }

  handleModalClose = () => {
    this.setState({ showConfirmAccountModal: false });
  }

  noAccount = () => {
    this.props.goToJoin();
  }

  handlePFResult = (result) => {
    const {
      value: {
        first_time,
        merged_account
      }
    } = result;

    if (!first_time) {
      return this.props.onSuccessfulPFLogin();
    }

    this.setState({
      first_time,
      merged_account,
      isPFLoginPending: false
    });
  };

  callLaunchDarkly = () => {
    const user = {
      'key': 'aa0ceb'
    };
    return new Promise((resolve, reject) => {
      const ldclient = LDClient.initialize(String(process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID), user, {
        bootstrap: 'localStorage' });

      setTimeout(() => {
        if (this.state.shouldShowPFLogin === null) {
          this.setState({ shouldShowPFLogin: false });
        }
      }, 10000);

      ldclient.on('ready', () => {
        const showPFLoginFlag = ldclient.variation('show-pf-login', false);
        this.setState({ shouldShowPFLogin: showPFLoginFlag });
        resolve();
      });
    });
  }

  componentDidMount() {
    if (this.state.shouldShowPFLogin === null) {
      this.callLaunchDarkly();
    }
  }

  render() {
    const {
      first_time,
      merged_account,
      PFError,
      isPFLoginPending,
      shouldShowPasswordLogin
    } = this.state;

    if (isPFLoginPending) {
      return <PFConnecting />;
    }

    if (first_time) {
      return (
        <PFStatus
          mergedAccount={ merged_account }
          done={ this.props.onSuccessfulPFLogin }
          openTermsOfUse={ openTermsOfUse }
          openPrivacyPolicy={ openPrivacyPolicy }
          acceptToS = { this.props.acceptToS }
        />
      );
    }

    if (PFError) {
      return <PFStatus error={ PFError } />;
    }

    if (shouldShowPasswordLogin) {
      return (
        <PFLogin
          close={ this.hidePasswordLogin }
          handleSubmit={ this.handlePFResult }
        />
      );
    }

    if (this.state.shouldShowPFLogin === null) {
      return <div />;
    }

    return (
      <div className={ classNames('email-login', this.props.mediaType) }>
        {
          this.props.appName === 'wolf'
            ? <FloatingBar backFunction={ this.handleWolfBack } skipNavigation={ true } />
            : <FloatingBar />
        }
        { this.renderEmailInput() }

      </div>
    );
  }

  handlePFLogin = () => {
    this.props.clearFields('email-login', false, false, 'password', 'email');
    this.props.facebookLogin.clearErrors();

    if (this.state.shouldUseAuth0SDK) {
      this.setState({
        isPFLoginPending: true,
        PFError: null,
        userCancelledPFLogin: false,
        appleError: undefined
      });
      this.useAuth0SDK();
    } else {
      this.usePasswordLogin();
    }
  }

  handleAppleLogin = async () => {
    this.props.clearFields('email-login', false, false, 'password', 'email');
    this.setState({ isAppleLoginPending: true, appleError: undefined, userCancelledPFLogin: false });
    this.props.facebookLogin.clearErrors();
    try {
      await this.props.getAppleLogin();
      this.setState({ isAppleLoginPending: false, appleError: undefined });
    } catch (e) {
      console.error(e);
      const errorMessage = e.message === 'Native' ? 'Sign in with Apple cancelled' : 'There was an error attempting to sign in with Apple';
      this.setState({ isAppleLoginPending: false, appleError: errorMessage });
    }
  }

  usePasswordLogin = () => {
    this.setState({ shouldShowPasswordLogin: true });
  }

  hidePasswordLogin = () => {
    this.setState({ shouldShowPasswordLogin: false });
  }

  useAuth0SDK = async () => {
    let auth;
    try {
      auth = await this.props.getPFAuth();
    } catch (e) {
      this.setState({
        PFError: null,
        isPFLoginPending: false,
        userCancelledPFLogin: true
      });

      return;
    }


    try {
      const {
        access_token,
        expires_in,
        id_token,
        refresh_token
      } = auth.value;

      const result = await this.props.loginWithPlanetFitness({
        access_token,
        expires_in,
        id_token,
        refresh_token
      });

      this.handlePFResult(result);
    } catch (e) {
      this.setState({
        PFError: {
          action: this.goBackFromError,
          message: e.message,
          buttonText: 'Go Back'
        },
        isPFLoginPending: false
      });
    }
  }

  renderEmailInput() {
    return (
      <section className="multi-login-section">
        <div className="login-options">
          {
            this.state.shouldShowPFLogin &&
          <button
            className="login-button pf-button"
            onClick={ this.handlePFLogin }
          >
            <img src={ pfLogo } alt="" />
            Log in with Planet Fitness
          </button>
          }
          { this.state.userCancelledPFLogin && this.state.shouldShowPFLogin &&
            <p className="error-text" style={ styles.errorStyle }>
              Log in with Planet Fitness cancelled
            </p>
          }
          <button
            className="login-button facebook-button"
            onClick={ this.loginViaFacebook }
          >
            <Icon
              name={ NAMES.FACEBOOK_BOXED }
              color={ scienceBlue }
              size={ 18 }
              unitSize="px"
            />
            Log in with Facebook
          </button>
          { this.props.facebookLogin.error
            ? <p className="error-text" style={ styles.errorStyle }>{ this.props.facebookLogin.error }</p>
            : null
          }
          { this.props.signInWithAppleEnabled &&
            <button
              className="login-button apple-button"
              onClick={ this.handleAppleLogin }
            >
              <Icon
                name={ NAMES.APPLE }
                color={ solidBlack }
                size={ 18 }
                unitSize="px"
              />
              Sign in with Apple
            </button>
          }
          { this.state.appleError
              && <p className="error-text" style={ styles.errorStyle }>{ this.state.appleError }</p>
          }
          <div className="or-container">
            <p>or</p>
          </div>
        </div>
        <form onSubmit={ this.props.handleSubmit(this.submitForm) } noValidate >
          { this.props.facebookLogin.pending || this.state.isAppleLoginPending ? <div className="overlay" /> : null }
          <InputIconDecorator
            iconVisible={ Boolean(this.props.email && this.props.valid) }
            iconColor={ greenApple }
            inputIcon={ MuiCheckIcon }
          >
            <Field
              name="email"
              type="email"
              component={ MuiTextField }
              normalize={ trim }
              className="form-field"
              hintText={ this.props.facebookToken ? 'Please enter your iFit email' : 'you@gmail.com' }
              floatingLabelText={ this.props.facebookToken ? 'Please enter your iFit email' : 'Email' }
              fullWidth={ true }
              errorStyle={ styles.errorStyle }
              errorText={ this.props.errorText }
              inputStyle={ styles.textStyle }
              hintStyle={ styles.textStyle }
              floatingLabelStyle={ this.props.error ? { ...styles.textStyle, ...styles.errorStyle } : styles.textStyle }
              floatingLabelFocusStyle={{ color: scienceBlue }}
              underlineFocusStyle={{ borderColor: scienceBlue }}
              autoCapitalize="off"
              autoCorrect="off"
              onChange={ this.clearPassword }
              onKeyPress={ this.setFocusOnPW }
            />
          </InputIconDecorator>
          { !this.props.submitting && this.props.error
            ? <p className="error-text" style={ styles.errorStyle }>{ this.props.error }</p>
            : null
          }

          <PasswordField
            validate={ this.validatePassword }
            onFocus={ this.clearPassword }
          />

          <MuiRaisedButton
            className="login-button button"
            type="submit"
            label={ !this.props.submitting ? 'Log in' : 'Logging in' }
            primary={ true }
            fullWidth={ true }
            style={ styles.buttonStyle }
            buttonStyle={ styles.buttonBorderStyle }
            labelStyle={ styles.buttonLabelStyle }
            disabled={ !this.props.valid || this.props.submitting }
          />

          <div className="forgot-password-container">
            <Navigation.JumpTo page="forgot-password">
              <a>Forgot Password?</a>
            </Navigation.JumpTo>
          </div>
          <ConfirmAccountModal
            isOpen={ this.state.showConfirmAccountModal }
            handleModalClose={ this.handleModalClose }
            noAccount={ this.noAccount }
          />
        </form>
      </section>
    );
  }
}

const LoginWithEmailPage = withFacebookLogin(PureLoginWithEmailPage);

const selector = formValueSelector('email-login');

export default connect(
  state => ({
    appName: state.config.appName,
    mediaType: state.config.mediaType,
    signInWithAppleEnabled: state.config.signInWithAppleEnabled,
    facebookToken: state.facebook.accessToken,
    email: selector(state, 'email')
  }),
  dispatch => ({
    loginViaEmail: async (email, password) => await dispatch(loginWithEmail(email, password)),
    onSuccessfulLogin: () => dispatch(Navigation.forward()),
    getPFAuth: async () => await dispatch(getPlanetFitnessAuth()),
    getAppleLogin: async () => await dispatch(getLoginWithApple()),
    loginViaPlanetFitnessSSO: async code => await dispatch(loginViaPlanetFitnessSSO(code)),
    loginWithPlanetFitness: async authObj => await dispatch(loginWithPlanetFitness(authObj)),
    onSuccessfulPFLogin: async () => await dispatch(setUserAuthCredentials()),
    acceptToS: async () => await dispatch(acceptToS()),
    closeWebview: () => dispatch(closeWebview()),
    goToJoin: () => dispatch(Navigation.jumpTo('create-account-login-info')),
    connectFacebook: async (token) => {
      await dispatch(connectFacebook(token));
    }
  })
)(
  reduxForm({
    form: 'email-login',
    validate
  })(LoginWithEmailPage)
);
